import { render, staticRenderFns } from "./editBuildingFormView.vue?vue&type=template&id=8ed74110&scoped=true"
import script from "./editBuildingFormView.vue?vue&type=script&lang=js"
export * from "./editBuildingFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed74110",
  null
  
)

export default component.exports